// extracted by mini-css-extract-plugin
export default {"tab":"tab_HUlL9_5","tab_transparent":"tab_transparent_bKxiY23","counter":"counter_fgUaVO2"};